import { AddressTypeEnum } from "@/shared/ModelEnums";

export default class SchoolAddressModel {
  addressTypeCd: AddressTypeEnum;
  street: string;

  suburbOrCity: string;
  australianStateCd: string;
  postcode: string;
  constructor() {
    this.addressTypeCd = AddressTypeEnum.AT_Ph;
    this.street = "";

    this.suburbOrCity = "";
    this.australianStateCd = "";
    this.postcode = "";
  }
}
